import { RouteConfig } from "vue-router";

export const ShopCustomersRoutes: Array<RouteConfig> = [ {
                path: 'customers',
                name: 'shop-customers',
                component: () => import(/* webpackChunkName: "shop-customers" */ './views/ShopCustomersPage.vue'),
                children: [{
                    path: 'new',
                    name: 'shop-new-customer',
                    component: () => import('./views/ShopCreateCustomer.vue')
                  }, {
                    path: 'discounts',
                    name: 'shop-discounts',
                    component: () => import('./views/ShopDiscounts.vue')
                  }]
        },
]